module.exports = __webpack_public_path__ + "img/portrait-064.408a7d4a.jpg";